import React from "react";
import Svg from "components/elements/svg";

const TermsFiles = () => (
  <section className="terms__files">
    <div className="container">
      <p className="terms__files--meta">
        Please note that the below terms apply in addition to our{" "}
        <a href="/terms-of-use">Terms of Website Use</a>.
      </p>
      <div className="row">
        <div className="col-sm-6">
          <a
            href="/static/files/buyer-terms.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="term-file"
          >
            <Svg className="term-file__icon" src="terms" />
            <div className="term-file__meta">
              <h2 className="filename">Buyers terms & conditions</h2>
              <p className="filedesc">Learn more (.pdf) »</p>
            </div>
          </a>
        </div>
        <div className="col-sm-6">
          <a
            href="/static/files/seller-terms.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="term-file"
          >
            <Svg className="term-file__icon" src="terms" />
            <div className="term-file__meta">
              <h2 className="filename">Sellers terms & conditions</h2>
              <p className="filedesc">Learn more (.pdf) »</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default TermsFiles;
